<script>
import {
    layoutComputed
} from "@/state/helpers";
import Vertical from "./vertical";
import Horizontal from "./horizontal";

export default {
    components: {
        Vertical,
        Horizontal,
    },
    data() {
        return {};
    },
    computed: {
        ...layoutComputed,
    },
    methods: {},
    mounted() {
        // document.querySelector("html").setAttribute('dir', 'rtl');
    }
};
</script>

<template>
    
<div >
    <!-- <v-img
      src="@/assets/images/unica-fundo.jpeg"
      alt="Descrição da imagem"
      max-width="100%"
      max-height="100%"
    ></v-img> -->
    
    <Vertical v-if="layoutType === 'vertical'" :layout="layoutType" class="background-component">
        <slot />
    </Vertical>

    <Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">
        
        <slot />
    </Horizontal>
</div>
</template>



<style>
.background-component2 {
  background-image: url("../../assets/images/unica-fundo.jpeg");
  background-size: cover; /* Redimensiona a imagem para cobrir todo o espaço */
  background-repeat: no-repeat; /* Evita a repetição da imagem */
  /* background-position: center center; */ /* Centraliza a imagem */
}
.background-component {
  background-image: url("../../assets/images/unica-fundo.jpeg");
  background-size: 100vw; /* Redimensiona a imagem para cobrir todo o espaço */
  background-repeat: no-repeat; /* Evita a repetição da imagem */
  background-position: center top;
  
 
   
    
}
</style>
